/* eslint-disable import/prefer-default-export */
import Vue from 'vue';

export function mapErrorsToInputs(errors) {
  const mappedErrors = {};
  if (errors.response && errors.response.status === 422) {
    Object.keys(errors.response.data.errors).forEach((key) => {
      mappedErrors[key] = errors.response.data.errors[key];
    });
  }
  return mappedErrors;
}

export function scrollToFirstError() {
  Vue.nextTick().then(() => {
    const el = document.querySelector('.v-messages.error--text');
    if (el) {
      el.scrollIntoView();
    }
  });
}
